import { render, staticRenderFns } from "./ChannelIndex.vue?vue&type=template&id=d215e9ee&scoped=true&"
import script from "./ChannelIndex.vue?vue&type=script&lang=js&"
export * from "./ChannelIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=d215e9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215e9ee",
  null
  
)

export default component.exports